<template>
<div class="animated fadeIn manage-store">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <b-tabs v-model="tabIndex">
            <b-tab active :title="$t('WEEKLYPERFORMANCESUMMARY')">
              <weeklyperformancesummarywin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex" v-bind:tabIndexParent="tabIndexParent"></weeklyperformancesummarywin>
            </b-tab>
            <b-tab :title="$t('WEEKLYMINIMUMSPLANNER')">
              <weeklyminimumsplannerwin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex" v-bind:tabIndexParent="tabIndexParent"></weeklyminimumsplannerwin>
            </b-tab>
            <b-tab :title="$t('CONSOLIDATEDMONTHLY')">
              <consolidatemonthlywin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex" v-bind:tabIndexParent="tabIndexParent"></consolidatemonthlywin>
            </b-tab>
            <b-tab :title="$t('STOREQUARTERLYMINIMUMSSUMMARY')">
              <storequarterlyminimumwin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex" v-bind:tabIndexParent="tabIndexParent"></storequarterlyminimumwin>
            </b-tab>
            <b-tab :title="$t('INDIVIDUALQUARTERLYMINIMUMSSUMMARY')">
              <quartelyindividiualwin v-bind:storeId="storeId" v-bind:tabIndex="tabIndex" v-bind:tabIndexParent="tabIndexParent"></quartelyindividiualwin>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'

import WeeklyPerformanceSummaryWin from './WeeklyPerformanceSummaryWin'
import WeeklyMinimumsPlannerWin from './WeeklyMinimumsPlannerWin'
import StoreQuarterlyMinimumWin from './StoreQuarterlyMinimumWin'
import QuartelyIndividiualWin from './QuartelyIndividiualWin'
import ConsolidateMonthlyWin from './ConsolidateMonthlyWin'

export default
{
  name: 'ReportsWin',
  props: ['storeId', 'tabIndexParent', 'childTab'],
  components:
  {
    weeklyperformancesummarywin: WeeklyPerformanceSummaryWin,
    weeklyminimumsplannerwin: WeeklyMinimumsPlannerWin,
    storequarterlyminimumwin: StoreQuarterlyMinimumWin,
    quartelyindividiualwin: QuartelyIndividiualWin,
    consolidatemonthlywin: ConsolidateMonthlyWin
  },
  data()
  {
    var me = this;
    return {
      tabIndex: 0
    }
  },
  async created()
  {
    var me = this;
  },
  watch:
  {
    
  }
}
</script>
